@if(basket$ | async; as basket) {
    @if(basket?.lines?.length > 0) {
        <div class="titles">
            <span>{{ 'BASKET.PRODUCT_NAME_LABEL' | translate }}</span>
            <span></span>
            <span class="center">{{ 'BASKET.UNIT_PRICE_LABEL' | translate }}</span>
            <span class="center">{{ 'BASKET.TOTAL_PRICE_LABEL' | translate }}</span>
        </div>
        <div class="lines">
            @for(line of basket?.lines | parents; track line.id) {
                <app-basket-line class="line"
                    [line]="line"
                    [addons]="basket?.lines | addons: line.id"
                    [basket]="basket">
                </app-basket-line>
            }
        </div>
    } @else {
        <h1 class="message">{{ 'BASKET.EMPTY' | translate }}</h1>
    }
} @else {
    <h1 class="message">{{ 'BASKET.NOT_LOADED' | translate }}</h1>
    <button class="message"
            (click)="get()">{{ 'BASKET.RELOAD' | translate }}</button>
}
